export default  {
    
    TYPE :  {
        INIT : 'INIT',
        LOCAL : 'LOCAL',
        PRODUCTION : 'PRODUCTION',
        IDUNDEFINED : 'ID UNDEFINED',
    },
    TEST : {
        
    }
}